import {gql} from "@apollo/client"

export const GET_LEGAL_TERMS = gql`
  query GetLegalTerms($term: String!) {
    GetLegalTerms(term: $term) {
      name
      id
      text
      message
      code
    }
  }
`;
